module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play_ja-776aaf11f2e329feb24a64536950f4a3.png";